import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import MaterialSelector from '../MaterialSelector'
import ImageScrubber from '../ImageScrubber'
import { withTranslation, Trans } from 'react-i18next'
import { interiorView02ImageOptions } from './views/InteriorView02'
import { interiorView03ImageOptions } from './views/InteriorView03'

class Xr41Fabric extends Component {
  constructor (props) {
    super(props)
    this.handleFabricChange = this.handleFabricChange.bind(this)
  }

  handleFabricChange (newValue) {
    let configuration = this.props.configuration
    configuration.Fabric = newValue
    configuration.FabricOwners = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    const image = (
      <ImageScrubber
        images={[
          <ConfiguratorImage
            key='view02'
            boat='Xr41'
            configuration={this.props.configuration}
            options={interiorView02ImageOptions}
          />,
          <ConfiguratorImage
            key='view01'
            boat='Xr41'
            configuration={this.props.configuration}
            options={interiorView03ImageOptions}
          />
        ]}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Fabrics' />
          </h1>

          {this.props.configuration.Layout.value !== 3 ? (
            <React.Fragment>
              <p>
                <Trans defaults='Choose upholstery for cushions in saloon.' />
              </p>
              <MaterialSelector
                options={this.props.FabricOptions}
                label={this.props.configuration.Fabric.label}
                value={this.props.configuration.Fabric}
                onChange={this.handleFabricChange}
              />
            </React.Fragment>
          ) : (
            <p>
              <Trans defaults='Fabric options are not available for the Race layout.' />
            </p>
          )}
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41Fabric)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41Fabric.js